// @flow
type OverlayToggleActionType = 'OVERLAY/TOGGLE';

export type ActionType = OverlayToggleActionType;

type OverlayToggleAction = {
    type: OverlayToggleActionType,
    payload: {isShowing: boolean}
};

export type Action = OverlayToggleAction;

export const OVERLAY_TOGGLE = 'OVERLAY/TOGGLE';

const ACTION_CREATORS = {
    toggleOverlay(isShowing: boolean): OverlayToggleAction {
        return {type: OVERLAY_TOGGLE, payload: {isShowing}};
    }
};

export default {
    ...ACTION_CREATORS
};
